import styles from './CitationBox.module.scss'

export type StoryLineCitationType = {
  readonly fields: {
    readonly citation: string
    readonly author: string
  }
}

export default function CitationBox({ item }: { readonly item: { model: StoryLineCitationType } }) {
  const model = item.model
  return (
    <blockquote className={styles.blockquote}>
      <div className={styles.citation}>{model.fields.citation}</div>
      <cite className={styles.autor}>{model.fields.author}</cite>
    </blockquote>
  )
}
